export default __webpack_public_path__ + "locales/ko-KR/PaymentsEnterprise.json?hash=9441a682b853114f0bb650908ff53de7";